export default __webpack_public_path__ + "static/media/21.61db8efb.png";